export default "__VITE_ASSET__BZWQChxO__"